import { axiosApi } from "services/api";

// Register User
export const registerUser = (data) => axiosApi.post('/register', data);

// Login User
export const loginUser = (data) => axiosApi.post('/login', data);

// Send Forgot Password Mail
export const sendForgotPasswordMail = (data) => axiosApi.post('/send/reset-code', data);

// Reset Password
export const resetPassword = (data) => axiosApi.post('/reset/password', data);

// Verify User OTP
export const verifyOtp = (data) => axiosApi.post('/verify-otp', data);

// Resend OTP
export const resendOtp = (data) => axiosApi.post('/resendOtp', data);

// API call for fetching notifications
export const getNotifications = async (token) => {
    console.log('Calling API with token:', token);
    try {
        const response = await axiosApi.get("/notifications/get", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.log(error)
        throw error; // Throw the error to be handled in the action/reducer
    }
};

// API call to get user data
export const getUserData = async (token, needNewProfileImage = false) => {
    try {
        const response = await axiosApi.get("/me", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                include_profile_image_url: needNewProfileImage,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user data:", error);
        throw error;
    }
};
